import axios from '@fs/zion-axios'

/**
 * Gets the source language from an artifact or group, with a fallback to 'en'.
 * Checks the artifact's languages first, then falls back to the group's languages, and defaults to 'en' if neither is available.
 *
 * @param {Object} artifact - The artifact containing language information
 * @param {Object} group - The group data containing language information
 * @returns {string} The source language code or 'en' as fallback
 */
export function getSourceLanguage(artifact, group) {
  return artifact?.languages?.[0] || group?.languages?.[0] || 'en'
}

/**
 * Translates text using the translated API
 * @param {string} text - The text to translate
 * @param {string} sourceLanguage - The source language of the text
 * @param {string} targetLanguage - The language to translate to
 * @returns {Promise<string>} Promise resolving to translated text
 */
export async function translateWithTranslatedApi(text, sourceLanguage, targetLanguage) {
  const response = await axios.post('/records/improve/translatedApi', {
    text,
    sourceLanguage,
    targetLanguage,
  })

  if (response.data.error) {
    throw new Error(`Translation failed: ${response.data.error}`)
  }

  return response.data.translation
}
